import React from 'react'
import { Box, Chip, Tooltip } from '@mui/material'
import { CheckCircle, HourglassEmpty, CloudDownload } from '@mui/icons-material'
import useDataStatusStore from '../stores/useDataStatusStore'

const DataStatus = () => {
  const { status, message } = useDataStatusStore()

  const getStatusColor = () => {
    switch (status) {
      case 'ready':
        return 'success'
      case 'loading':
      case 'fetching_enquiries':
        return 'warning'
      default:
        return 'default'
    }
  }

  const getStatusIcon = () => {
    switch (status) {
      case 'ready':
        return <CheckCircle />
      case 'fetching_enquiries':
        return <CloudDownload />
      case 'loading':
      default:
        return <HourglassEmpty />
    }
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Tooltip title={message} arrow>
        <Chip
          icon={getStatusIcon()}
          label={message}
          color={getStatusColor()}
          size="small"
          variant="outlined"
        />
      </Tooltip>
    </Box>
  )
}

export default DataStatus
